import React from 'react'

export default function Title() {
  return (
    <div><h4 className='announcement-title'><span>Announcement</span></h4></div>
  )
}
